import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Data2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 4.5H11.25V6H3V4.5ZM13.5 4.5H21V6H13.5V4.5ZM15.75 9H21V10.5H15.75V9ZM8.25 9H13.5V10.5H8.25V9ZM3 9H6V10.5H3V9ZM3 13.5H21V15H3V13.5ZM3 18H15.75V19.5H3V18ZM18 18H21V19.5H18V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Data2.vue"]]);
